import { useCallback } from "react";

/**
 * 文件上传与附件管理 Hook
 * 封装文件选择、验证、上传和移除等操作
 */
const useFileUploadHandlers = ({
  attachedFiles,
  setAttachedFiles,
  fileInputRef,
  isInExpertMode,
  selectedExpert,
  sessionId,
  showNotification,
}) => {
  // 文件选择处理
  const handleFileChange = useCallback((event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      // 检查是否在文档分析助手专家模式下
      if (!isInExpertMode || !selectedExpert || selectedExpert.comd !== "document_query") {
        showNotification('请先点击曲别针按钮进入文档分析模式', 'warning');
        return;
      }

      // 文件类型验证
      const allowedTypes = ['.pdf', '.doc', '.docx', '.txt', '.md'];
      const validFiles = files.filter(file => {
        const extension = '.' + file.name.split('.').pop().toLowerCase();
        return allowedTypes.includes(extension);
      });

      if (validFiles.length !== files.length) {
        showNotification('部分文件类型不支持，仅支持 PDF、DOC、DOCX、TXT、MD 格式', 'warning');
      }

      // 文件大小验证（单文件最大10MB）
      const oversizedFiles = validFiles.filter(file => file.size > 10 * 1024 * 1024);
      if (oversizedFiles.length > 0) {
        showNotification('部分文件超过10MB大小限制', 'warning');
        return;
      }

      // 总文件数量限制（最多5个）
      if (attachedFiles.length + validFiles.length > 5) {
        showNotification('最多只能同时上传5个文件', 'warning');
        return;
      }

      setAttachedFiles(prev => [...prev, ...validFiles]);
    }
  }, [attachedFiles, isInExpertMode, selectedExpert, setAttachedFiles, showNotification]);

  // 移除附件
  const handleRemoveAttachment = useCallback((index) => {
    setAttachedFiles(prev => prev.filter((_, i) => i !== index));
    // 清空文件输入框，以便可以重复上传同一个文件
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [fileInputRef, setAttachedFiles]);

  // 清空所有附件
  const clearAttachments = useCallback(() => {
    setAttachedFiles([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [fileInputRef, setAttachedFiles]);

  return {
    handleFileChange,
    handleRemoveAttachment,
    clearAttachments,
  };
};

export default useFileUploadHandlers;
